import HomeSlider from './HomeSlider';
import Strip from './Strip';
import About from './About';
import Work from './Work';
import WorkedWith from './WorkedWith';
import QuoteSection from './QuoteSection';

function Content(){
    return(
        <>
            <HomeSlider />
            <Strip />
            <About/>
            <Work/>
            <WorkedWith/>
            <QuoteSection/>
        </>
    );
}
export default Content;